class AnimatedScroll {
	constructor(config) {
		this.config = Object.assign({
			scope: '.animated_scroll',
			desktop: {
				stickyStart: 98,
				stackOffset: 0,
			},
			mobile: {
				stickyStart: 75,
				stackOffset: 0,
			},
			breakpoint: 992, // lg
		}, config);

		$(document).ready(() => {
			this.$scope = $(this.config.scope);

			if (this.$scope.length > 0) {
				this.init();
			}
		});
	}

	init() {
		this.$scope.each((_, scope) => {
			const cards = Array.from($(scope).find('[data-animated-scroll-card]'));
			this.#initCards(cards);
			this.#bindEvents(scope, cards);
		});
	}

	#getConfig() {
		return window.innerWidth >= this.config.breakpoint
			? this.config.desktop
			: this.config.mobile;
	}

	#initCards(cards) {
		const { stickyStart, stackOffset } = this.#getConfig();

		cards.forEach((card, i) => {
			$(card).css({
				top:    (stickyStart + i * stackOffset) + 'px',
				zIndex: i + 1
			});
		});
	}

	#bindEvents(scope, cards) {
		const update = () => this.#update(scope, cards);
		$(window).on('scroll.animatedScroll', update);
		$(window).on('resize.animatedScroll', () => {
			this.#initCards(cards);
			update();
		});
		update();
	}

	#update(scope, cards) {
		const { stickyStart } = this.#getConfig();
		const scopeRect       = scope.getBoundingClientRect();
		const cardHeight      = cards[0]?.getBoundingClientRect().height ?? 0;
		const scrolled        = Math.max(0, stickyStart - scopeRect.top);

		cards.forEach((card, i) => {
			const $inner = $(card).find('.animated-scroll__inner');

			if (i === cards.length - 1) {
				$inner.css({ transform: 'scale(1)', opacity: 1 });
				return;
			}

			const start    = i * cardHeight;
			const progress = Math.max(0, Math.min(1, (scrolled - start) / cardHeight));

			$inner.css({
				transform: `scale(${1 - progress * 0.1})`,
				opacity:   1 - progress,
			});
		});
	}
}

export default new AnimatedScroll;
